import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const Synology = () => import('@/views/Synology.vue')

const routes = [
  {
    path: '',
    component:Synology
  },
  {
    path:'/',
    component:Synology
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router